import { styled, css } from '@creditas/stylitas'

const StatusLabel = styled.div<{ enabled?: boolean; borderColor?: string }>`
  background: #fff;
  height: 32px;
  display: flex;
  border-radius: 16px;
  padding: 4px;
  padding-right: 8px;
  text-align: right;
  margin: 4px 6px;
  border: 1px solid #556666;
  color: #556666;

  .circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 4px 8px 4px 4px;
    background: #778888;
  }

  ${props =>
    props.enabled &&
    css`
      border-color: #4499ee;

      .circle {
        background: #4499ee;
      }
    `}

  ${props =>
    props.borderColor !== null &&
    css`
      border-color: ${props.borderColor};

      .circle {
        background: ${props.borderColor};
      }
    `}
`
export { StatusLabel }
